import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

const useModalInnerStore = defineStore('modalInner', () => {
	const isDeleteEventConfirmationModalVisible = ref(false)

	return {
		isDeleteEventConfirmationModalVisible
	}
})

export const useModalStore = defineStore('modal', () => {
	const innerStore = useModalInnerStore()

	const isDeleteEventConfirmationModalVisible = computed(() => innerStore.isDeleteEventConfirmationModalVisible)

	function openDeleteEventConfirmationModal() {
		innerStore.isDeleteEventConfirmationModalVisible = true
	}

	function closeDeleteEventConfirmationModal() {
		innerStore.isDeleteEventConfirmationModalVisible = false
	}

	return {
		isDeleteEventConfirmationModalVisible,
		openDeleteEventConfirmationModal,
		closeDeleteEventConfirmationModal
	}
})
